import load from "./modules/load-assets";
import easy from "./modules/easyReveal";
import lazy from "./modules/lazy-image-load";
import carousel from "./modules/carousel";
import forms from "./modules/forms";
import stream from "./modules/stream";
import CustomScroll from "./modules/custom-scroll";
import PortraitReveal from "./modules/portrait-reveal";

const v = document.querySelector("[data-version]").getAttribute("data-version");
console.log(`VERSION ${v}`);
const themeName = "direct-positive";
const theme = `/wp-content/themes/${themeName}`;

//initialize lazy load of images
lazy.init();
easy.init();

window.onload = () => {
    load.asset(`${theme}/non-critical.css`, "link");
};

//load fonts
load.asset(`${theme}/fonts.css`, "link");
load.asset("https://use.typekit.net/gax5vaf.css", "link");

stream.init();

// const dynamicVideos = document.querySelector('[data-dynamic-video]');
// if( dynamicVideos ) {
//      let videoStyles = false; //makes sure that videJS stylesheet is only loaded once per session
//      console.log('loading videoJS');
//      const initVideos = function() {
//           !videoStyles ? load.asset('//vjs.zencdn.net/7.10.2/video-js.min.css', 'link', () => { videoStyles = true; }) : false;
//           const id = dynamicVideos.getAttribute('id');
//           console.log('id', id);
//           const videoPlayer = id ? videojs( id ) : false;
//           videoPlayer.ready( () => {
//                console.log('player ready');
//                const player = this;
//                setTimeout(() => {
//                     console.log('play');
//                     // player.play();
//                 }, 500);
//           } );
//       }
//       //Make sure the library is loaded
//       window.videojs ? initVideos() : load.asset('//vjs.zencdn.net/7.10.2/video.min.js', 'script', initVideos)
// }

/***********************************
// Carousels
************************************/
const carousels = document.querySelectorAll("[data-carousel]");
if (carousels.length > 0) {
    console.log("found");
    window.siema
        ? initCarousels(carousels)
        : load.asset(`${theme}/assets/js/vendor/siema.min.js`, "script", () => {
              initCarousels(carousels);
          });
}

const drawers = document.querySelectorAll("[data-component-accordion]");
if (drawers.length > 0) {
    drawers.forEach((drawer) => {
        drawer.addEventListener(
            "click",
            () => {
                drawer.classList.toggle("active");
                const container = drawer.nextElementSibling;
                const height = container.clientHeight;
                const scroll = container.scrollHeight;
                console.log(container, height, scroll);
                height < scroll
                    ? (container.style.maxHeight = `${scroll}px`)
                    : (container.style.maxHeight = 0);
            },
            { passive: true }
        );
    });
}

PortraitReveal.theme = theme;
PortraitReveal.init();
CustomScroll.init();
